import React from 'react';
import * as yup from 'yup';
import FormSection from '../../../../common/membershipFormComponents/FormSection';

const fields = [
  {
    colSpan: 1,
    name: 'numberGas',
    type: 'text',
    label: 'Number',
  },
  {
    colSpan: 1,
    name: 'countryOfOriginGas',
    type: 'text',
    label: 'Country of Origin',
  },
  {
    colSpan: 1,
    name: 'capacityGas',
    type: 'text',
    label: 'Capacity (KW/Hour)',
  },
];

export const gasExtraFieldsValidation = {
  [fields[0].name]: yup.string().label(fields[0].label).nullable(),
  [fields[1].name]: yup.string().label(fields[1].label).nullable(),
  [fields[2].name]: yup.string().label(fields[2].label).nullable(),
};

const GasExtraSection = (props) => {
  return <FormSection sectionName="Gas" sectionColumn={3} formFields={fields} {...props} />;
};

export default GasExtraSection;
